<template>
  <div class="app">
    <div>
      <h3 class="tt">A.O.史密斯<br />用户安装实例</h3>
      <div class="user-info">
        <div class="headimg">
          <img
            src="https://pro-core.babycdn.com/2020/08aosmith/images2020/release_case/headimg.jpg"
          />
        </div>
        <div class="info">
          <h3>案例信息</h3>
          <div class="txt">
            <span>城市：{{ oDetails.city_name }}</span
            ><span>小区：{{ oDetails.address }}</span>
          </div>
          <div class="txt" v-if="oDetails.house_area">
            面积：{{ oDetails.house_area }}m²
          </div>
        </div>
      </div>
      <div class="case-list">
        <!-- <h3>安装案例</h3> -->
        <div class="case-item" v-if="oDetails.genre_img">
          <h5>口碑晒单</h5>
          <div class="image-wrap">
            <img v-lazy="oDetails.genre_image[0].img_url" alt="图片" />
          </div>
        </div>

        <div
          class="case-item"
          v-for="item in oDetails.new_scenes"
          :key="item.id"
        >
          <h5>{{ item.scenes_name ? item.scenes_name + "场景" : "" }}</h5>
          <div
            class="image-wrap"
            v-for="(imgitem, imgindex) in item.house_img"
            :key="imgindex"
          >
            <img
              v-lazy="imgitem.img_url"
              alt="图片"
              @click="swiperChange(item.arrImg, imgindex)"
            />
          </div>
          <div class="viebeo" v-if="item.mp4">
            <video
              :id="`video${item.id}`"
              :src="item.mp4_info.mp4_url"
              controls
              :poster="item.mp4_info.mp4_rectangle_cover_url"
              webkit-displaying-fullscreen="false"
              x-webkit-airplay="true"
              x5-playsinline="true"
              webkit-playsinline="true"
              playsinline="true"
            ></video>
            <!-- preload="auto" -->
            <!-- src="../../assets/images/case/vi.mp4" -->
          </div>
          <div id="output"></div>
          <div class="goods-wrap" v-if="item.goods_info.length">
            <div class="titel">
              <span class="left"></span>
              案例中的商品
              <span class="right"></span>
            </div>
            <ul class="goods-list">
              <li
                v-for="git in item.goods_info"
                :key="git.id"
                v-if="git.id"
                @click="godetails(git.id)"
              >
                <div class="img-box">
                  <img :src="git.mobile_thumb" />
                </div>
                <div class="title">
                  <div>{{ git.goods_type_name }}</div>
                  <div>{{ git.goods_name }}</div>
                  <div
                    class="selling"
                    v-for="(gitem, gindex) in git.attr"
                    :key="gindex"
                    v-if="gitem.attr_mean < 4 && gindex < 3"
                  >
                    <span>{{ gitem.attr_value ? "·" : "" }}</span
                    >{{ gitem.attr_value }}
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="btn">
        <div
          class="collection"
          @click.stop="getcollection"
          v-if="oDetails.is_collect == 0"
        >
          收藏案例
        </div>
        <div
          class="collection"
          @click.stop="getcollection"
          v-if="oDetails.is_collect == 1"
        >
          取消收藏
        </div>
        <!-- @click="bShow = true" -->
        <div class="sharecollection" @click="getShare()">分享案例</div>
      </div>
      <!-- 分享提示弹窗 -->
      <div v-if="bShow">
        <div class="popup" @click.stop="bShow = false"></div>
        <div class="kuang">
          <div class="top">是否在分享案例中添加引流活动？</div>
          <div class="bottom">
            <div @click="gosarelink">直接分享</div>
            <div @click="gosarea">添加活动</div>
          </div>
        </div>
      </div>
      <!-- 预览图片 -->
      <div class="preview-img" v-show="showSwiper">
        <swiper :options="swiperOption" ref="mySwiper">
          <swiper-slide v-for="item in arrSwiperImg" :key="item.id">
            <div class="swiper-zoom-container">
              <img :src="item" alt />
            </div>
          </swiper-slide>
          <!--<div class="swiper-pagination "  slot="pagination"></div>-->
        </swiper>
      </div>
      <div v-show="showSwiper" class="close-preview" @click="closeSwiper">
        关闭预览
      </div>
      <!-- 预览头图 -->
      <div class="preview-img" v-show="headerSwiper">
        <swiper :options="swiperOptiontwo" ref="mySwipertwo">
          <swiper-slide v-for="item in arrHeaderImg" :key="item.id">
            <div class="swiper-zoom-container">
              <img :src="item" alt />
            </div>
          </swiper-slide>
          <div class="swiper-pagination" slot="pagination"></div>
        </swiper>
      </div>
      <div v-show="headerSwiper" class="close-preview" @click="getheaderSwiper">
        关闭预览
      </div>
    </div>
    <div class="logo">
      <img src="@/assets/images/system/logo2.png" />
    </div>
    <!-- <div v-for="(item, index) in arrAttr" :key="index"></div> -->
  </div>
</template>
<script>
import path from "@/path.js";
import { swiper, swiperSlide } from "vue-awesome-swiper";
export default {
  components: {
    swiper,
    swiperSlide,
  },
  data() {
    return {
      oDetails: "", //案例详情
      headimg: "",
      bShow: false,
      showSwiper: false, //预览图片
      headerSwiper: false, //预览头图
      arrHeaderImg: [], //头图
      arrSwiperImg: [], //需要预览的图片
      swiperIndex: 0,
      swiperIndextwo: 0,
      swiperOption: {
        clickable: true,
        noSwiping: true,
        zoom: true,
        on: {
          slideChangeTransitionStart: function (swiper) {
            this.swiperIndex = this.swiper.activeIndex;
          }.bind(this),
        },
      },
      swiperOptiontwo: {
        clickable: true,
        noSwiping: true,
        zoom: true,
        on: {
          slideChangeTransitionStart: function (swipertwo) {
            this.swiperIndextwo = this.swipertwo.activeIndex;
          }.bind(this),
        },
      },
      userinfo: {}, //用户信息
    };
  },
  created() {
    this.headimg = this.$route.query.headimg;
    this.$store.commit("loadSwitch", true);
    this.getDetails();
  },
  computed: {
    swiper() {
      this.swiperIndex = this.$refs.mySwiper.swiper.activeIndex;
      //  console.log("实例", this.swiperIndex);
      return this.$refs.mySwiper.swiper;
    },
    swipertwo() {
      this.swiperIndextwo = this.$refs.mySwipertwo.swiperIndextwo.activeIndex;
      return this.$refs.mySwipertwo.swiperIndextwo;
    },
  },
  methods: {
    // 分享判断
    getShare() {
      this.bShow = true;
    },
    //点击打开预览
    swiperChange(arr, index) {
      var that = this;
      //  console.log(index);
      if (index >= 0) {
        that.showSwiper = true;
        this.arrSwiperImg = [];
        this.arrSwiperImg = arr;
        that.swiper.slideTo(index, 1000, true);
      }
    },
    //点击关闭预览
    closeSwiper() {
      var that = this;
      that.showSwiper = false;
    },
    //点击打开预览头图
    headerChange(index) {
      var that = this;
      //  console.log(index);
      if (index >= 0) {
        that.headerSwiper = true;
        that.swiper.slideTo(index, 1000, true);
      }
    },
    //点击关闭预览头图
    getheaderSwiper() {
      var that = this;
      that.headerSwiper = false;
    },
    //点击跳转详情页
    godetails(id) {
      //  console.log("商品id", id);
      wx.miniProgram.navigateTo({ url: `/pages/pro_type_v2/index?id=${id}` });
    },
    //跳转直接
    gosarelink() {
      this.bShow = false;
      this.$store.commit("loadSwitch", true);
      path
        .post5(path.getUser, { user_id: this.$route.query.tp5Userid })
        .then((res) => {
          //  console.log("用户信息", res);
          this.userinfo = res.data.data.result;
          this.$store.commit("loadSwitch", false);
          if (res.data.data.result.sell_id == 0) {
            // this.$toast({
            //   message: "您不是直销员",
            //   duration: 500,
            // });
            // setTimeout(() => {
            wx.miniProgram.navigateTo({
              url: `/pages/phoneauth/index?url=/pages/case/share/index&userid=${this.$route.query.userid}&topicid=${this.$route.query.topicid}`,
            });
            // }, 500);
          } else {
            wx.miniProgram.navigateTo({
              url: `/pages/case/share/index?userid=${this.$route.query.userid}&topicid=${this.$route.query.topicid}`,
            });
          }
        });
    },

    //跳转添加活动页面
    gosarea() {
      this.bShow = false;
      this.$store.commit("loadSwitch", true);
      path
        .post5(path.getUser, { user_id: this.$route.query.tp5Userid })
        .then((res) => {
          //  console.log("用户信息", res);
          this.userinfo = res.data.data.result;
          this.$store.commit("loadSwitch", false);
          if (this.userinfo.sell_id == 0) {
            // this.$toast({
            //   message: "您不是直销员",
            //   duration: 500,
            // });
            // setTimeout(() => {
            wx.miniProgram.navigateTo({
              url: `/pages/phoneauth/index?url=/pages/watersystem/activity/index&userid=${this.$route.query.userid}&topicid=${this.$route.query.topicid}&from=case`,
            });
            // }, 500);
          } else {
            wx.miniProgram.navigateTo({
              url: `/pages/watersystem/activity/index?userid=${this.$route.query.userid}&topicid=${this.$route.query.topicid}&from=case`,
            });
          }
        });
    },
    //收藏案例
    getcollection() {
      let data = {
        type: "topic",
        user_id: this.$route.query.tp5Userid,
        xid: this.oDetails.id,
        title:
          this.oDetails.province_name +
          "-" +
          this.oDetails.city_name +
          "-" +
          this.oDetails.address,
        source: "xcx",
      };
      this.$store.commit("loadSwitch", true);
      path.post5(path.topicCollect, data).then((res) => {
        //  console.log("收藏案例", res);
        if (res.data.error == 0) {
          this.$store.commit("loadSwitch", false);
          this.$toast({
            message: res.data.data.result.msg,
            duration: 500,
          });
          // this.getDetails(); 收藏无需刷新数据
          this.oDetails.is_collect = this.oDetails.is_collect === 0 ? 1 : 0;
        }
      });
    },
    getDetails() {
      let data = {
        topic_id: this.$route.query.topicid,
        source: "xcx",
        user_id: this.$route.query.userid,
        is_share: 0,
      };
      this.$store.commit("loadSwitch", true);
      path.post5(path.gettopic, data).then((res) => {
        if (res.data.error == 0) {
          this.$store.commit("loadSwitch", false);
          this.oDetails = res.data.data.result;
          let arrNewscenes = res.data.data.result.new_scenes;
          let arrSwiperImg = [];
          let arrHeaderImg = [];
          arrHeaderImg.push(res.data.data.result.cover);
          this.arrHeaderImg = arrHeaderImg;
          arrNewscenes.forEach((it) => {
            it.arrImg = [];
            it.house_img.forEach((img) => {
              it.arrImg.push(img.img_url);
              // console.log(img.img_url)
              // arrSwiperImg.push(img.img_url)
              // this.arrSwiperImg=arrSwiperImg;
              // console.log(this.arrSwiperImg)
            });
            // if (it.mp4 != "") {
            //   console.log(it);
            //   this.formLabelAlign(it.id);
            // }
          });
        }
        //  console.log("案例详情", res);
      });
    },
    formLabelAlign(id) {
      //  console.log("canvas", id);
      this.$nextTick(() => {
        let video = document.getElementById("video" + id);
        video.currentTime = 1;
        video.crossOrigin = "Anonymous"; //canvas跨域获取图片
        //  console.log(video);
        video.addEventListener("loadeddata", function () {
          //  console.log("视频加载完毕");
          let canvas = document.createElement("canvas");
          canvas.width = video.clientWidth;
          canvas.height = video.clientWidth;
          // video.crossOrigin = 'Anonymous' //canvas跨域获取图片
          canvas
            .getContext("2d")
            .drawImage(video, 0, 0, canvas.width, canvas.width);
          let img = document.createElement("img");
          let imgsrc = canvas.toDataURL("image/png");
          //  console.log(imgsrc);
          video.poster = canvas.toDataURL("image/png");
          // console.log(video)
        });
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import 'details.scss';
</style>
